import { Tooltip } from 'react-tooltip'
import styled from 'styled-components'

import { Box } from 'app/components/design-system-components'

const StyledLi = styled(Box)`
  border-bottom: ${(props) => props.theme.borders[1]};
  border-color: ${(props) => props.theme.colors.gray200};

  ${({ theme, danger }) => danger && `color: ${theme.colors.error600};`}

  &:last-child {
    border-bottom: none;
  }
`

export const ToolsButton = ({
  tools = [],
  componentClass = '',
  className = '',
  disabled = false,
}) => {
  return (
    <div className={`dropdown actions ${componentClass} ${className}`}>
      <div
        className={`dropdown-toggle drop-down-toggler ${
          disabled && 'disabled'
        }`}
        data-toggle="dropdown"
      >
        <i className="icon-more drop-down-spots"></i>
      </div>
      <ul className="dropdown-menu team-overview-dropdown">
        {tools &&
          tools.map((tool, index) => {
            const {
              enableTool = false,
              onClick,
              text = '',
              className = '',
              tooltipId,
              danger = false,
            } = tool || {}
            return (
              <StyledLi
                key={index}
                className={`link-styles ${
                  enableTool ? '' : 'd-none'
                } ${className}`}
                onClick={onClick}
                {...(tooltipId && {
                  'data-tooltip-content': '',
                  'data-tooltip-id': tooltipId,
                })}
                danger={danger}
              >
                {text}
              </StyledLi>
            )
          })}
      </ul>
      {tools &&
        tools.map(
          ({ tooltipText, tooltipId }) =>
            tooltipId && <Tooltip id={tooltipId}>{tooltipText}</Tooltip>,
        )}
    </div>
  )
}

export const ToolsButtonWithTextComponent = ({
  tools = [],
  buttonText = '',
  componentClass = '',
  optionsClass = '',
}) => {
  return (
    <div className={`dropdown actions ${componentClass}`}>
      <div className="dropdown-toggle dropdown-button" data-toggle="dropdown">
        {buttonText}
      </div>
      <ul className={`dropdown-menu team-overview-dropdown ${optionsClass}`}>
        {tools &&
          tools.map((tool, index) => {
            const {
              enableTool = false,
              alwaysVisible = false,
              onClick,
              text = '',
              upgradeRecommendation,
            } = tool || {}

            const TENANCY_TRANSFER_TEXT = 'Tenancy Transfer'
            const shouldShow = enableTool || alwaysVisible
            const isDisabled = !enableTool
            const isTenancyTransfer = text === TENANCY_TRANSFER_TEXT

            if (!shouldShow) {
              return null
            }

            const isTenancyTransferDisabled = isTenancyTransfer && isDisabled

            // Extract opacity logic
            const getOpacity = () => {
              if (isTenancyTransferDisabled) return 1
              if (isDisabled) return 0.6
              return 1
            }

            // Extract display properties for tenancy transfer
            const getTenancyTransferDisplayProps = () => {
              if (isTenancyTransfer && isDisabled && upgradeRecommendation) {
                return {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }
              }
              return {
                display: 'block',
                alignItems: 'normal',
                justifyContent: 'normal',
              }
            }

            return (
              <li
                key={index}
                className={`link-styles ${isDisabled ? 'disabled' : ''}`}
                onClick={
                  isDisabled
                    ? isTenancyTransferDisabled
                      ? (e) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }
                      : undefined
                    : onClick
                }
                style={{
                  cursor: isDisabled ? 'default' : 'pointer',
                  opacity: getOpacity(),
                  // Only set background and color for disabled Tenancy Transfer
                  ...(isTenancyTransferDisabled && {
                    backgroundColor: '#F5F5F5',
                    color: '#686d71',
                  }),
                  ...getTenancyTransferDisplayProps(),
                }}
                onMouseEnter={
                  isTenancyTransferDisabled
                    ? (e) => {
                        // Keep original color on hover - no color change
                        e.currentTarget.style.setProperty(
                          'color',
                          '#686d71',
                          'important',
                        )
                        // Keep background color on hover
                        e.currentTarget.style.setProperty(
                          'background-color',
                          '#F5F5F5',
                          'important',
                        )
                      }
                    : undefined
                }
                onMouseLeave={
                  isTenancyTransferDisabled
                    ? (e) => {
                        // Maintain original color when not hovering
                        e.currentTarget.style.setProperty(
                          'color',
                          '#686d71',
                          'important',
                        )
                        // Keep background color
                        e.currentTarget.style.setProperty(
                          'background-color',
                          '#F5F5F5',
                          'important',
                        )
                      }
                    : undefined
                }
              >
                {text}
                {isDisabled &&
                  upgradeRecommendation &&
                  (isTenancyTransfer ? (
                    <div
                      style={{ fontSize: '12px' }}
                      onClick={(e) => {
                        e.stopPropagation()
                      }}
                    >
                      {upgradeRecommendation}
                    </div>
                  ) : (
                    <div
                      style={{ marginTop: '8px', fontSize: '12px' }}
                      onClick={(e) => {
                        e.stopPropagation()
                      }}
                    >
                      {upgradeRecommendation}
                    </div>
                  ))}
              </li>
            )
          })}
      </ul>
    </div>
  )
}
export default ToolsButton
